"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDigestOptionDto = instanceOfDigestOptionDto;
exports.DigestOptionDtoFromJSON = DigestOptionDtoFromJSON;
exports.DigestOptionDtoFromJSONTyped = DigestOptionDtoFromJSONTyped;
exports.DigestOptionDtoToJSON = DigestOptionDtoToJSON;
exports.DigestOptionDtoToJSONTyped = DigestOptionDtoToJSONTyped;
var DigestCopyDto_1 = require("./DigestCopyDto");
/**
 * Check if a given object implements the DigestOptionDto interface.
 */
function instanceOfDigestOptionDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    return true;
}
function DigestOptionDtoFromJSON(json) {
    return DigestOptionDtoFromJSONTyped(json, false);
}
function DigestOptionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'label': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['label']),
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'parentIds': json['parentIds'] == null ? undefined : json['parentIds'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}
function DigestOptionDtoToJSON(json) {
    return DigestOptionDtoToJSONTyped(json, false);
}
function DigestOptionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'label': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['label']),
        'groupId': value['groupId'],
        'parentIds': value['parentIds'],
        'imageUrl': value['imageUrl'],
        'sortOrder': value['sortOrder'],
    };
}
